import { Vehicle, VehicleFilters } from '../../../../app/models/Vehicle';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import VehicleFilter from './VehicleFilter';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import VehicleSwitchChange from '../VehicleSwitchChange';

interface Props {
    vehicles: Vehicle[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: VehicleFilters;
    setFilter: (filter: VehicleFilters) => void;
    callbackSuccess: () => void;
    onSearch: () => void;
}

const VehicleDataTable = ({
    vehicles,
    totalRows,
    loading = false,
    edit,
    destroy,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            width: '80px',
            cell: (row: Vehicle) => <span>{row.id}</span>
        },
        {
            name: 'Patente',
            selector: (row: any) => row.patent,
            sortable: true,
            sortField: 'patent',
            cell: (row: Vehicle) => <span>{row.patent}</span>
        },
        {
            name: 'Tipo',
            selector: (row: any) => row.vehicle_type,
            sortable: true,
            sortField: 'vehicle_type',
            cell: (row: Vehicle) => <span>{row.vehicle_type}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            width: '100px',
            cell: (row: Vehicle) => (
                <VehicleSwitchChange
                    checkValue={row.is_active ?? true}
                    vehicleId={row.id!}
                    callbackSuccess={callbackSuccess}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            width: '150px',
            cell: (row: Vehicle) => (
                <div className="">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row?.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row?.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <VehicleFilter filter={filter} setFilter={setFilter} onSearch={onSearch} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={vehicles}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default VehicleDataTable;
